import { render } from "./OperacionesCSVDashboard.vue?vue&type=template&id=20f2385b&scoped=true"
import script from "./OperacionesCSVDashboard.vue?vue&type=script&lang=js"
export * from "./OperacionesCSVDashboard.vue?vue&type=script&lang=js"

import "./OperacionesCSVDashboard.vue?vue&type=style&index=0&id=20f2385b&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f2385b"]])

export default __exports__